import { Component, OnInit, ChangeDetectorRef, ViewChild, Renderer, ElementRef } from "@angular/core";
import { NgZone } from "@angular/core";
// import { ApiAiClient } from 'api-ai-javascript';
import { Jsonp } from "@angular/http/src/http";
import { Http, Headers } from "@angular/http";
import * as $ from "jquery";
declare var ApiAi: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  // image_URL: any = 'assets/imgs/'; //Local path
  //image_URL: any = 'http://192.168.103.100:7002/TeamOdisha/chat-bot/assets/imgs/'; //Server paththeirs  
  // image_URL: any = "http://203.129.207.122/teamodishaV2/chat-bot/assets/imgs/" //staging
  image_URL: any = "https://investodisha.gov.in/chat-bot/assets/imgs/" //staging
  // image_URL: any = 'http://pp.bhubaneswarone.in/chat-bot/assets/imgs/'; //pp path
  // image_URL: any = 'http://203.129.207.122:8090/bbsronestg/chat-bot/assets/imgs/'; //Staging path
  title = 'app';
  description: string = ''
  ext: any = ''
  serviceURL: string = ''
  scrollEle: any;
  textValue: any = '';
  answers = [];
  userNameData: string = '';
  userPasswordData: string = '';
  passIsActive: string = '0';
  password: string = '';
  weatherIsActive: string = '0';
  weatherData = [];
  date: string = '';
  high: number;
  low: number;
  temp: number;
  city: string = '';
  text: string = '';
  date1: string = '';
  message: any = '';
  url: string = '';
  loginType: number;
  object: {};
  btnActive = '0';
  placeholder: any = 'Enter Message';
  showChatbot: boolean = false;
  type: any = 'text';
  typing: number;
  chkBtnText: string = '';
  isLogin: string = "";
  // loginUrl: string = 'http://pp.bhubaneswarone.in/signup';
  // loginUrl: string = 'http://203.129.207.122:8090/bbsronestg/signup';
  loginUrl: string = 'http://192.168.103.102/bhubaneswarone/signup';
  messageAry: any = ['I am happy to help. Please click on the link below',
    'Sure. Can you please click on this link to get you right there',
    'Am glad to help you. Please click the link below',
    'Definitely. Please do click the link displayed below to redirect you to the respective form'
  ];
  customServiceAry: any = ["View Map", "View Direction", "View Weather", "Location"];
  customServiceAryval: any = [{ "View Map": "Google Maps is a web mapping service developed by Google. It offers satellite imagery, street maps, 360° panoramic views of streets (Street View), real-time traffic conditions (Google Traffic), and route planning for traveling by foot, car, bicycle (in beta), or public transportation." },
  { "View Direction": "Google Maps provides a route planner, allowing users to find available directions through driving, public transportation, walking, or biking. Google has partnered globally with over 800 public transportation providers to adopt General Transit Feed Specification (GTFS), making the data available to 3rd parties." },
  { "View Weather": "Get the weather forecast details of the place can for the next seven days. The current weather along with hourly, daily and weekly forecast can be traced. Also the weather and season trend can be traced for the location desired." },
  { "Location": "The Location Info is a developer and diagnostic tool which gathers the location information from the map and displays the same. Also gives the navigation path from one place to the other. Gives the best free way to share, embed, print actionable location info anywhere." }]
  fallback: any = '';
  fallbackAry: any = ['Sorry, can you say that again?',
    'Sorry, I did not get that',
    'I did not get that.',
    'Sorry, can you say that again?'
  ]
  client = new ApiAi.ApiAiClient({ accessToken: '67cbe889678f42e29becb8ebc6d96e53' });
  autoFocus: any = "";
  constructor(public ngZone: NgZone, private http: Http, public ref: ChangeDetectorRef, public renderer: Renderer) { }

  ngOnInit() {
    this.scrollEle = document.getElementById('chat_time_scroll_pos_bottom');
    this.answers = [];
    this.isLogin = sessionStorage.getItem('loginSuccess');
    var data = sessionStorage.getItem('loginSuccess');
    var data1 = sessionStorage.getItem('loginUser');

  }

  getMyLocation() {
    this.typing = 1
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.typing = 0
        var customText = "~View Location~Google Maps is a web mapping service developed by Google. It offers satellite imagery, street maps, 360° panoramic views of streets (Street View), real-time traffic conditions (Google Traffic), and route planning for traveling by foot, car, bicycle (in beta), or public transportation.";
        let tempURL = 'url-https://www.google.co.in/maps/@' + position.coords.latitude + ',' + position.coords.longitude + customText;
        this.answers.push({ type: 0, speech: tempURL, isUrl: 1, isBtn: -1, btnObj: [] });
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }

  entClicked(evt) {
    if (evt.keyCode === 13) {
      if (this.textValue === '') {
        alert('Please ask me something!');
      } else {
        this.ask(this.textValue, 0);
        this.textValue = '';
      }
    }
  }
  callBot() {
    this.showChatbot = !this.showChatbot;
    this.autoFocus = 'autofocus'
    this.ref.detectChanges();
    this.answers = [];
    if (this.isLogin == null)
      var data = sessionStorage.getItem('loginSuccess');
    var data1 = sessionStorage.getItem('loginUser');
    if (this.answers.length == 0) {
      if (data == null) {
        this.typing = 1;
        // setTimeout(() => {
        this.typing = 0
        this.ask('hi Odishi', 0);
        // this.answers.push({ type: 0, speech: 'Welcome! I’m B1, and I’ve been programmed to help you get what you need from Bhubaneswar Smart City! ', isUrl: -1, isBtn: -1, btnObj: [] });

      }
      else {
        this.ask('Hello Odishi', 0);
      }
    }
  }
  ask(question, type) {
    if (this.customServiceAry.indexOf(question) == -1) {
      let mailVal = 0;
      if (this.answers.length > 0) {
        if (this.answers[this.answers.length - 1].speech == 'Please Enter your email-Id') {
          mailVal = 1;
        }
        else {
          mailVal = 0;
        }
        let pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (pattern.test(question) == true) {
          // this.answers.push({ type: 0, speech: "Please wait...", isUrl: -1, isBtn: -1, btnObj: [] });
          mailVal = 0;
          this.userNameData = question;
        }
        else {
          // alert(this.answers[this.answers.length-1].speech)
          if (this.answers[this.answers.length - 1].speech != 'Please Enter your email-Id') {
            mailVal = 0;
          }
          else {
            mailVal = 1;
            this.answers.push({ type: 1, speech: question, isUrl: -1, isBtn: -1, btnObj: [] });
            this.answers.push({ type: 0, speech: 'Please Enter your email-Id', isUrl: -1, isBtn: -1, btnObj: [] });
          }
        }
      }

      if (type == 1) {
        this.passIsActive = '0';
      }
      if (this.passIsActive == '1') {
        // setTimeout(() => { this.passInput.setFocus() }, 500);
        for (let i = 0; i < question.length; i++) {
          this.password = this.password.concat('*');
        }

        this.answers.push({ type: 1, speech: this.password, isUrl: -1, isBtn: -1, btnObj: [] });
        this.password = '';
        var param1 = {
          "user_name": this.userNameData,
          "password": btoa(question)
        }
        let headers: Headers = new Headers();

        headers.append('Authorization', 'Basic YmJzcm9uZUAyMDE4OlZLY0VoNFduQk9SVXAyY21GUmQzWTBSell4UVcxV1I=');

        this.http.post(this.getUrl(this.url) + 'chatbotLogin', param1, { headers: headers }).subscribe(response => {
          var res = JSON.parse(response['_body']);
          setTimeout(() => {
            var currObj = this;
            this.textValue = '';
            if (res.status == 'success') {
              this.passIsActive = '0';
              // console.log(res.result);

              // this.answers.push({ type: 0, speech: 'Hello ' + res.result.name + '. What are you looking for? ', isUrl: -1, isBtn: 0, btnObj: ['', 'Certificate', 'Booking', 'Grievance'] });// , 'Bill', 'Property', 'Planning', 'Others'

              // window.open(i.speech.substring(4, i.speech.length));res.result.redirectUrl
              // let importantStuff = window.open('https://www.google.com/', '_blank');//https://www.google.com/
              // let win = window.open(res.result.redirectUrl);
              // win.blur();
              // window.open(res.result.redirectUrl, 'targetWindow', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=400,height=600')
              // current.focus();
              // var win = window.open(res.result.redirectUrl, "foobar");
              // location.reload(res.result.redirectUrl);
              sessionStorage.setItem('loginSuccess', '1');
              sessionStorage.setItem('loginUser', res.result.name);
              this.showChatbot = true;
              // location.reload(res.result.redirectUrl);
              window.open(res.result.redirectUrl, "_self")
              // window.open("http://localhost:4200/", "_self")
            }
            else {
              this.typing = 1
              this.answers.push({ type: 0, speech: 'You have enter an invalid password. Please try again or go to .', isUrl: -1, isBtn: 0, btnObj: ['', 'Forgot Password'] });
              this.passIsActive = '1';
            }
          }, 3000)
        })
      }
      else {
        if (mailVal == 0) {
          var data = sessionStorage.getItem('loginSuccess');
          var data1 = sessionStorage.getItem('loginUser');
          if (data !== null) {
            this.loginType = 1;
          }
          else {
            this.loginType = 2;
          }
          this.message = this.messageAry[Math.floor(Math.random() * this.messageAry.length)];
          this.fallback = this.fallbackAry[Math.floor(Math.random() * this.fallbackAry.length)];
          this.client.textRequest(question).then((response) => {
            this.textValue = '';
            const x = JSON.stringify(response.result.fulfillment);
            // if (question == 'no' || question == 'No' || question == 'NO' || question == 'Exit' || question == 'exit' || question == 'Cancel' || question == 'cancel') {
            //   this.ask("Hello B1", 0);
            // }
            // else{

            // }
            if (this.answers.length != 0 && question != "Hello Odishi") {
              this.answers.push({ type: 1, speech: question, isUrl: -1, isBtn: -1, btnObj: [] });
            }
            response.result.fulfillment['messages'].forEach(i => {
              let chkURL; let chkBtn; let chkApi; let uname; let password; let chkApiWeather; let weatherApi; let weatherDate; let currDate;
              let today; let dd; let mm; let yyyy; var day; var hr; var min; let description; let parseCurrDate; let parseWeatherDate;
              if (this.loginType === 1 && i.speech === "How can i help you with the following services ? /Login or Sign Up/Certificate(Birth or Death)/Marriage Registration/Booking of assets/Grievance/View Weather/Location") {
                this.typing = 1
                setTimeout(() => {
                  this.typing = 0
                  this.answers.push({ type: 0, speech: 'Hello ' + data1 + '. What are you looking for? ', isUrl: -1, isBtn: 0, btnObj: ['', 'Certificate(Birth or Death)', 'Marriage Registration', 'Booking of Assests', 'Grievance', 'View Weather', 'Location'] });// , 'Bill', 'Property', 'Planning', 'Others'
                }, 3000)
              }
              else {
                currDate = new Date();
                currDate = this.getOnlyDate(currDate);
                parseCurrDate = Date.parse(currDate);
                chkURL = i.speech.search('url');
                chkBtn = i.speech.search('/');
                chkApi = i.speech.search('APILOGIN');
                chkApiWeather = i.speech.search('APIWeather');
                //console.log(i.speech.split(',')[1])
                // this.serviceURL = i.speech.split(',')[0];
                // this.chkBtnText = i.speech.split(',')[1];
                // this.description = i.speech.split(',')[2];
                let chkBtnData = [];
                this.weatherIsActive = '0';

                if (chkBtn !== -1 && chkURL === -1) {
                  chkBtnData = i.speech.split('/');
                }
                if (chkBtnData.length > 0) {
                  this.typing = 1
                  setTimeout(() => {
                    this.typing = 0
                    this.answers.push({ type: i.type, speech: chkBtnData[0], isUrl: chkURL, isBtn: chkBtn, btnObj: chkBtnData });
                  }, 3000)

                } else {
                  if (chkApi == -1 && chkApiWeather == -1) {
                    if (this.answers.length == 0) {
                      // setTimeout(() => {
                      //   // this.answers.push({ type: 0, speech: 'Welcome to Bhubaneswar Smartbot.', isUrl: -1, isBtn: -1, btnObj: [] });
                      // }, 3000)
                    }
                    if (chkURL !== -1) {
                      this.btnActive = '0';
                      // setTimeout(() => {
                      //   this.typing = 1
                        // this.answers.push({ type: 0, speech: this.message, isUrl: -1, isBtn: -1, btnObj: [] });
                      // }, 3000)
                    }
                    if (i.speech == '') {
                      this.typing = 1
                      //this.answers.push({ type: 0, speech: 'https://www.google.co.in/search?q='+question, isUrl: 1, isBtn: -1, btnObj: [] });
                      //this.answers.push({ type: 0, speech: this.fallback, isUrl: -1, isBtn: -1, btnObj: [] });
                      if (question !== "reset B1")
                        // this.answers.push({ type: 0, speech: this.message, isUrl: -1, isBtn: -1, btnObj: [] });
                      setTimeout(() => {
                        this.typing = 0
                        var customText = "~View on Google~Create good titles and snippets in Search Results. Google's generation of page titles and descriptions is completely automated and takes into account both the content of a page as well as references to it that appear on the web.";
                        if (question !== "reset B1")
                          this.answers.push({ type: 0, speech: 'url-https://google.co.in/search?q=' + question + customText, isUrl: 1, isBtn: 0, btnObj: [] });
                      }, 3000)
                    }
                    else {
                      if (i.speech === 'Searching your location please wait...') {
                        this.typing = 1
                        setTimeout(() => {
                          this.typing = 0
                          this.getMyLocation();
                        }, 3000)
                        this.typing = 1
                      }
                      if (i.speech == "I didn't get that") {
                        this.typing = 1
                        this.answers.push({ type: 0, speech: this.message, isUrl: -1, isBtn: -1, btnObj: [] });
                        setTimeout(() => {
                          this.typing = 0;
                          var customText = "~View on Google~Create good titles and snippets in Search Results. Google's generation of page titles and descriptions is completely automated and takes into account both the content of a page as well as references to it that appear on the web.";
                          this.answers.push({ type: 0, speech: 'url-https://google.co.in/search?q=' + question + customText, isUrl: 1, isBtn: 0, btnObj: [] });
                        }, 3000)
                      }
                      else {
                        this.typing = 1
                        setTimeout(() => {
                          this.typing = 0
                          if (question == 'hi Odishi') {
                            this.answers.push({ type: i.type, speech: i.speech, isUrl: chkURL, isBtn: 0, btnObj: chkBtnData });
                            this.ask('Hello Odishi', 0);
                          }
                          else {
                            var spch=i.speech.split('~')[0].substring(4, i.speech.split('~')[0].length)
                            this.ext = spch.split('.')[spch.split('.').length - 1]
                            if (this.ext == "pdf" || this.ext == "PDF") {
                              window.open(i.speech.split('~')[0].substring(4, i.speech.split('~')[0].length))
                            }
                            else {
                              this.answers.push({ type: i.type, speech: i.speech, isUrl: chkURL, isBtn: 0, btnObj: chkBtnData });
                            }
                          }
                          setTimeout(() => {
                            // alert(chkURL)
                            if (chkURL !== -1) {
                              this.answers.push({ type: i.type, speech: "Are you happy with my answer?", isUrl: -1, isBtn: 0, btnObj: ["", "Yes", "No"] });
                            }

                          }, 3000)
                        }, 3000)
                      }

                    }
                  }
                  else {

                  }
                }
                // if (chkURL !== -1) {
                //   // window.open(i.speech.substring(4, i.speech.length));
                //   this.answers.push({ type: 0, speech: this.message, isUrl: -1, isBtn: -1, btnObj: [] });
                // }
                if (chkApi !== -1) {
                  var currObj = this;
                  this.typing = 1
                  setTimeout(() => {
                    this.typing = 0
                    this.answers.push({ type: 0, speech: i.speech.split(',')[1], isUrl: -1, isBtn: -1, btnObj: [] });
                  }, 3000)
                  // alert(i.speech)
                  uname = i.speech.split(',')[2];
                  if (uname != '') {
                    // this.userNameData = uname;
                    var param = {
                      "user_name": question,
                      "password": ''
                    }
                    let headers: Headers = new Headers();
                    // console.log(this.getUrl(this.url) + 'chatbotLogin')
                    headers.append('Authorization', 'Basic YmJzcm9uZUAyMDE4OlZLY0VoNFduQk9SVXAyY21GUmQzWTBSell4UVcxV1I=');
                    this.http.post(this.getUrl(this.url) + 'chatbotLogin', param, { headers: headers }).subscribe(response => {
                      var res = JSON.parse(response['_body']);
                      // alert('99999999999')
                      // console.log(question)
                      // console.log(res);
                      // console.log(this.getUrl(this.url) + 'chatbotLogin')
                      // console.log(param)
                      this.typing = 1
                      setTimeout(() => {
                        if (res.status == 'success') {
                          this.passIsActive = '1';
                          var params1 = {
                            "user_name": uname,
                            "login_type": 1
                          }
                          this.typing = 0
                          this.answers.push({ type: 0, speech: 'Hello ' + res.result.name + '. Please enter your password for verification.', isUrl: -1, isBtn: -1, btnObj: ['', 'Forgot Password'] });
                          // $("#textboxPass").focus();

                          this.placeholder = 'Enter Password';
                          this.type = 'password';

                          let headers: Headers = new Headers();

                          headers.append('Authorization', 'Basic YmJzcm9uZUAyMDE4OlZLY0VoNFduQk9SVXAyY21GUmQzWTBSell4UVcxV1I=');
                          this.http.post(this.getUrl(this.url) + 'chatbotLoginHistory', params1, { headers: headers }).subscribe(response => {
                            var res = JSON.parse(response['_body']);
                            // console.log(res);
                          })
                        }
                        else {
                          this.passIsActive = '0';
                          var params2 = {
                            "user_name": uname,
                            "login_type": 2
                          }
                          let headers: Headers = new Headers();
                          headers.append('Authorization', 'Basic YmJzcm9uZUAyMDE4OlZLY0VoNFduQk9SVXAyY21GUmQzWTBSell4UVcxV1I=');
                          this.http.post(this.getUrl(this.url) + 'chatbotLoginHistory', params2, { headers: headers }).subscribe(response => {
                            var res = JSON.parse(response['_body']);
                            // console.log(res);
                            // this.loginType = 2
                            this.answers.push({ type: 0, speech: 'You are not register yet.', isUrl: -1, isBtn: 0, btnObj: ['', 'Want to Register', 'Skip Register'] });
                          })
                        }
                      }, 3000);

                    })
                  }
                }
                if (chkApiWeather != -1) {
                  this.typing = 1
                  this.weatherIsActive = '1';
                  let parseDate; let dt; let dt1;
                  weatherApi = i.speech.split('~')[1];
                  weatherDate = i.speech.split('~')[2];
                  if (weatherDate === '') {
                    dt1 = this.getOnlyDate(currDate);
                  }
                  else {
                    dt1 = this.getOnlyDate(weatherDate);
                  }
                  parseWeatherDate = Date.parse(dt1);
                  let headers: Headers = new Headers();
                  this.http.get(weatherApi).subscribe(response => {
                    var res = JSON.parse(response['_body']);
                    description = res.query.results.channel.item.description;
                    this.city = res.query.results.channel.location.city;
                    this.temp = res.query.results.channel.item.condition.temp;
                    this.temp = this.toCelsius(this.temp);
                    this.ref.detectChanges();

                    for (let i = 0; i < res.query.results.channel.item.forecast.length; i++) {
                      this.date = res.query.results.channel.item.forecast[i].date;
                      dt = this.getOnlyDate(this.date);
                      parseDate = Date.parse(dt);
                      if (parseWeatherDate === parseDate) {
                        this.date1 = res.query.results.channel.item.forecast[i].date;
                        this.high = res.query.results.channel.item.forecast[i].high;
                        this.high = this.toCelsius(this.high);
                        this.low = res.query.results.channel.item.forecast[i].low;
                        this.low = this.toCelsius(this.low);
                        this.text = res.query.results.channel.item.forecast[i].text;
                      }
                    }
                    this.typing = 0
                    let obj = { 'city': this.city, 'temp': this.temp, 'date': this.date1, 'high': this.high, 'low': this.low, 'text': this.text }
                    this.answers.push({ type: 0, speech: obj, isUrl: -1, isBtn: 0, btnObj: [], isWeather: 1 });
                  })
                }
              }

            });
          })
            .catch((error) => {
            });
        }
      }
    }
    else {
      var text = "";
      //o = { "key1": "value1", "key2": "value2"};



      for (var i = 0; i < this.customServiceAryval.length; i++) {
        var textTxt = this.customServiceAryval[i][question]
        if (textTxt !== undefined) {
          text = textTxt;
          this.typing = 1
          this.answers.push({ type: 1, speech: question, isUrl: -1, isBtn: -1, btnObj: [], isWeather: -1 });
          setTimeout(() => {
            this.typing = 0
            this.answers.push({ type: 0, speech: text, isUrl: -1, isBtn: -1, btnObj: [], isWeather: -1 });
          }, 3000)

        }


      }


    }
    // if(question=="No" || question=="Exit" || question=="Cancel" || question=="no" || question=="exit" || question=="cancel"){
    //   this.answers.push({ type: 1, speech: question, isUrl: -1, isBtn: -1, btnObj: [] });
    //   setTimeout(() => {
    //     this.ask('no', 0);
    //   },3000);

    // }
    // else{

    // }

  }
  getUrl(URL) {
    // URL = 'http://192.168.103.102/bhubaneswarone/api/'
    URL = 'http://203.129.207.122:8090/bbsronestg/api/'
    // URL = 'http://pp.bhubaneswarone.in/api/'
    return URL;
  }
  toCelsius(f) {
    let t;
    t = ((5 / 9) * (f - 32)).toFixed(0)
    return t;
  }
  scroll_ele() {
    this.scrollEle.scrollTop = this.scrollEle.scrollHeight;
  }
  getOnlyDate(d) {
    let dd; let mm; let yyyy; let dt;
    dt = new Date(d);
    dd = dt.getDate();
    mm = dt.getMonth() + 1; // January is 0!
    yyyy = dt.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }

    dt = mm + '/' + dd + '/' + yyyy;
    return dt;
  }
}